import { clsx, type ClassValue } from "clsx"
import { gray, IColor } from "leaflet.glify/src/color";
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function hexToRgbNormalized(hex: string): IColor {
  if (
    typeof hex !== "string" ||
    !/^#?[0-9A-Fa-f]{3}$|^#?[0-9A-Fa-f]{6}$|^#?[0-9A-Fa-f]{8}$/.test(hex)
  ) {
    console.error("Invalid hex string");
    return gray; // Return default gray for invalid input
  }

  // Remove the '#' if present
  if (hex.startsWith("#")) hex = hex.slice(1);

  // Expand shorthand hex (e.g., 'RGB' -> 'RRGGBB')
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Parse RGB and optional alpha values
  const r = parseInt(hex.slice(0, 2), 16) / 255;
  const g = parseInt(hex.slice(2, 4), 16) / 255;
  const b = parseInt(hex.slice(4, 6), 16) / 255;
  const a = hex.length === 8 ? parseInt(hex.slice(6, 8), 16) / 255 : undefined;

  return { r, g, b, a };
}

export function getChosenColor(
  chosenColor:
    | string
    | IColor
    | [number, number, number]
    | [number, number, number, number]
): IColor {
  let rgb: IColor;

  // Handle hex string
  if (typeof chosenColor === "string") {
    rgb = hexToRgbNormalized(chosenColor);
  }
  // Handle normalized array
  else if (Array.isArray(chosenColor)) {
    let chosenColorArray = chosenColor;
    if (chosenColorArray.length === 3) {
      rgb = {
        r: chosenColorArray[0],
        g: chosenColorArray[1],
        b: chosenColorArray[2],
      };
    } else if (chosenColorArray.length === 4) {
      rgb = {
        r: chosenColorArray[0],
        g: chosenColorArray[1],
        b: chosenColorArray[2],
        a: chosenColorArray[3],
      };
    } else {
      throw new Error("Invalid array length for RGB or RGBA values.");
    }
  }
  // Handle RGB object
  else {
    rgb = chosenColor;
  }

  return rgb;
}